export default "__VITE_ASSET__Dy0KMSqQ__"